// extracted by mini-css-extract-plugin
export var footer = "_qu-0";
export var inherit = "_qu-1";
export var input = "_qu-2";
export var modalContent = "_qu-3";
export var quillEditor = "_qu-4";
export var subtitle = "_qu-5";